import type { TOrthoNeeds, TOrthoNeedsMarkType, IOrthoNeedsFilter } from "./types";
import { createPathParamCRUD, createPathParam, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "patient/ortho-needs";

export default createService(SLUG, {
  ...createPathParamCRUD<
    TOrthoNeeds,
    NoPathParams,
    IOrthoNeedsFilter,
    Partial<TOrthoNeeds>,
    Partial<TOrthoNeeds>
  >(SLUG),

  markAs: createPathParam<any, { id: string; type: TOrthoNeedsMarkType }, Record<string, never>>(
    `${SLUG}/{id}/{type}/`
  ),
});
